import {Component, Input} from '@angular/core';
import {Product} from "@app/core/product/domain/dtos/product";
import {CartLine} from "@app/core/cart/domain/dtos/cart-line";
import {IsPriceHiddenUseCase} from '@app/core/delivery-point/application/is-price-hidden.use-case';
import {PresentationConstants} from "@app/presentation/presentation.constants";

@Component({
  selector: 'ep-item-tile',
  templateUrl: './item-tile.component.html',
  styleUrls: ['./item-tile.component.scss']
})
export class ItemTileComponent {

  @Input() item?: Product | CartLine | null;

  @Input() promotionCode?: string | null = null;

  isPriceHidden$ = this.isPriceHiddenUseCase.execute();

  constructor(
    private isPriceHiddenUseCase: IsPriceHiddenUseCase
  ) { }

  protected readonly PresentationConstants = PresentationConstants;
}
